// src/hook.ts
import { isArray } from "@stepstone-genesis/utilities";
import { useActiveBreakpoint } from "@stepstone-genesis/hooks-use-active-breakpoint";
var useActiveBreakpointValue = (values, initialBreakpoint) => {
  const valueArray = isArray(values) ? values : [];
  const { isActive } = useActiveBreakpoint({ initialBreakpoint });
  return valueArray[isActive >= valueArray.length ? valueArray.length - 1 : isActive];
};
export {
  useActiveBreakpointValue
};
